import type { User } from "@/shared/api/generated/types.gen";
import { ApiError, apiClient, resetCsrfState } from "@/shared/api/client";

export type AdminUser = User;

export const authApi = {
  me: async (signal?: AbortSignal) => {
    try {
      return await apiClient<{ user: AdminUser }>("/me", {
        suppressUnauthorizedEvent: true,
        signal,
      });
    } catch (error) {
      if (error instanceof ApiError && error.status === 401) return null;
      throw error;
    }
  },
  login: (email: string, password: string, remember = false) =>
    apiClient<{
      user: AdminUser;
      access_token: null;
      token_type: null;
    }>("/auth/admin/login", {
      method: "POST",
      body: JSON.stringify({
        email,
        password,
        client_type: "web",
        remember,
      }),
    }),
  logout: async () => {
    try {
      return await apiClient<{ message: string }>("/auth/logout", {
        method: "POST",
        suppressUnauthorizedEvent: true,
      });
    } catch (error) {
      // An expired or already-ended server session is also signed out.
      if (error instanceof ApiError && error.status === 401) return { message: "Signed out." };
      throw error;
    } finally {
      resetCsrfState();
    }
  },
};
